<template>
  <div id="app">
    <!-- <div v-if="showNavbar"> -->
    <div v-if="1 == 2">
      <van-nav-bar
        :title="title"
        :left-text="leftText"
        :right-text="rightText"
        :z-index="1000"
        :left-arrow="showNavbarLeft"
        fixed
        :class="{ 'van-nav-bar-blue': navbarColor === 'blue' }"
        @click-left="onClickLeft"
        @click-right="onClickRight"
      />
      <div style="height: 46px"></div>
    </div>

    <router-view />

    <div v-if="showTabbar">
      <!-- <van-tabbar v-model="tabbarActiveIndex">
        <van-tabbar-item icon="wap-home" to="/">首页</van-tabbar-item>
        <van-tabbar-item icon="orders-o" to="/order">订单</van-tabbar-item>
        <van-tabbar-item icon="huiyuanka" @click="onMemberCardClick"
          >会员</van-tabbar-item
        >
        <van-tabbar-item icon="contact" to="/my">我的</van-tabbar-item>
      </van-tabbar> -->
      <van-tabbar v-model="tabbarActiveIndex" active-color="#52211d">
        <van-tabbar-item @click="toHome">
          <template #icon="props">
            <i class="f_i jjnjmxer" :class="props.active ? 'act' : ''"></i>
          </template>
          首页
        </van-tabbar-item>
        <van-tabbar-item @click="toOrder">
          <template #icon="props">
            <i class="f_i jjnjmxer ab" :class="props.active ? 'act' : ''"></i>
          </template>
          已约门票
        </van-tabbar-item>
        <!-- <van-tabbar-item @click="onMemberCardClick">
                <template #icon="props">
                    <i class="f_i jjnjmxer ac" :class="props.active?'act':''"></i>
                </template>
                会员
            </van-tabbar-item> -->
        <van-tabbar-item @click="onHelpClick">
          <template #icon="props">
            <i class="f_i jjnjmxer help" :class="props.active ? 'act' : ''"></i>
          </template>
          获取帮助
        </van-tabbar-item>
        <!-- <van-tabbar-item >
                <template #icon="props">
                    <i class="help" :class="props.active?'act':''"></i>
                </template>
               <a href="https://mp.weixin.qq.com/s/4bscNm2kHjku-1QeqtVclA" >获取帮助</a>
            </van-tabbar-item> -->
        <van-tabbar-item @click="toMemberCenter" v-if="!GDHRSSLogin">
          <template #icon="props">
            <i class="f_i jjnjmxer ad" :class="props.active ? 'act' : ''"></i>
          </template>
          我的
        </van-tabbar-item>
      </van-tabbar>
      <div style="height: 50px"></div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Input, Autocomplete } from "element-ui";

import {
  Tabbar,
  TabbarItem,
  NavBar,
  Dialog,
  Toast,
  Loading,
  Tab,
  Tabs,
  List,
  Row,
  Col,
  Cell,
  CellGroup,
  Button,
  Icon,
  ImagePreview,
  Panel,
  Popup,
  DatetimePicker,
  Form,
  Field,
  RadioGroup,
  Radio,
  Collapse,
  CollapseItem,
  Uploader,
  Stepper,
  Picker,
  Area,
  NumberKeyboard,
  Search,
  ActionSheet,
  CountDown,
  Tag,
  Switch,
  Checkbox,
  Calendar,
  Grid,
  GridItem,
  DropdownMenu,
  DropdownItem,
  Skeleton,
} from "vant";
import { mapState } from "vuex";
import appConsts from "./store/consts.js";
// import memberService from "./services/memberService.js";
import "./assets/iconfont.css";
import "./assets/iconfont.css";

Vue.use(Tabbar)
  .use(TabbarItem)
  .use(NavBar)
  .use(Dialog)
  .use(Toast)
  .use(Loading)
  .use(Tab)
  .use(Tabs)
  .use(List)
  .use(Row)
  .use(Col)
  .use(Cell)
  .use(CellGroup)
  .use(Button)
  .use(Icon)
  .use(ImagePreview)
  .use(Panel)
  .use(Popup)
  .use(DatetimePicker)
  .use(Form)
  .use(Field)
  .use(RadioGroup)
  .use(Radio)
  .use(Collapse)
  .use(CollapseItem)
  .use(Uploader)
  .use(Stepper)
  .use(Picker)
  .use(Area)
  .use(NumberKeyboard)
  .use(Search)
  .use(ActionSheet)
  .use(CountDown)
  .use(Tag)
  .use(Switch)
  .use(Checkbox)
  .use(Calendar)
  .use(Grid)
  .use(GridItem)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Input)
  .use(Autocomplete)
  .use(Skeleton);

Toast.setDefaultOptions({
  duration: 2000,
});

export default {
  data() {
    return {};
  },
  // created() {
  //           var u = navigator.userAgent
  //             var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  //             return
  //             if (isIOS) {// 判断是否是ios端
  //               let flag = false
  //               let pageBackNormFunc
  //               document.body.addEventListener('focusin', () => {
  //                   // 软键盘弹起事件
  //                   flag = true
  //                   pageBackNormFunc && clearTimeout(pageBackNormFunc)
  //               })
  //               document.body.addEventListener('focusout', () => {
  //                   // 软键盘关闭事件
  //                   if (flag) {
  //                       pageBackNormFunc = setTimeout(function() { // // 当键盘收起的时候让页面回到原始位置
  //                           window.scrollTo({
  //                               top: 0,
  //                               left: 0,
  //                               behavior: 'smooth'
  //                           })
  //                       }, 200)
  //                   }
  //                   flag = false
  //               })
  //           }
  //       },
  computed: {
    tabbarActiveIndex: {
      get() {
        return this.$store.state.tabbarActiveIndex;
      },
      set(value) {
        this.$store.commit(appConsts.activeTabbar, value);
      },
    },
    leftText() {
      return this.showNavbarLeft ? "返回" : "";
    },
    rightText() {
      return this.showNavbarRight ? "首页" : "";
    },
    ...mapState([
      "title",
      "showNavbar",
      "showNavbarLeft",
      "showNavbarRight",
      "navbarColor",
      "showTabbar",
      "GDHRSSLogin",
    ]),
    ...mapState({
      member: (state) => state.memberModule.member,
    }),
  },
  methods: {
    toHome() {
      this.$router.push("/").catch((errorData) => {errorData});
    },
    async toOrder() {
      // if (!memberService.isLogin()) {
      //   let loginUrl = await memberService.getLoginUrl("order");
      //   window.location.href = loginUrl;
      // } else {
        this.$router.push("/order").catch((errorData) => {errorData});
      // }
    },
    async toMemberCenter() {
      // if (!memberService.isLogin()) {
      //   let loginUrl = await memberService.getLoginUrl("my");
      //   window.location.href = loginUrl;
      // } else {
        this.$router.push("/my").catch((errorData) => {errorData});
      // }
    },
    onHelpClick() {
      window.open(window.helpURL, "_blank");
    },
    onClickLeft() {
      if (this.showNavbarLeft) {
        this.$router.go(-1);
      }
    },
    onClickRight() {
      if (this.showNavbarRight) {
        this.$router.push("/").catch((errorData) => {errorData});
      }
    },
    onMemberCardClick() {
      if (this.member.hasElectronicMemberCard) {
        this.$router.push("/membercard").catch((errorData) => {errorData});
      } else {
        //this.$router.push("/registmembercard");
        this.$toast("此功能暂未开放");
      }
    },
  },
  mounted() {
    this.$store.commit(
      "setClientHeight",
      document.documentElement.clientHeight
    );
  },
};
</script>

<style lang="scss">
@import "./assets/index.scss";
</style>